import { resolveStoredFileUrl } from "utils/storedFileUrl";
import { Collapse, Grid, Icon, IconButton, TableCell, TableRow } from "@mui/material";
import { Fragment, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import PropTypes from "prop-types";
import { formatMoneyPunto } from "utils/formatters";
import { nombreCompraDetalle } from "utils/presentacionCompra";

function FilaProducto(props) {
  const { row, openModal, setProductoElegido, removeLicitacion, cotizada } = props;
  const [open, setOpen] = useState(false);
  return (
    <Fragment>
      <TableRow
        sx={{
          backgroundColor: "#f5f5f5",
          cursor: "pointer",
          "&:hover": { backgroundColor: "#eef1f4" },
          "&:focus-visible": {
            outline: "3px solid rgba(240, 5, 122, 0.35)",
            outlineOffset: -3,
          },
        }}
        onClick={() => setOpen((previous) => !previous)}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            setOpen((previous) => !previous);
          }
        }}
        tabIndex={0}
        aria-expanded={open}
        aria-label={`Ver detalle de ${row.materiaPrima?.nombre || row.nombreServicio || "producto"}`}
      >
        <TableCell sx={{ m: 0, p: 0 }}>
          <Grid container py={{ xs: 0.9, sm: 0 }} px={{ xs: 0.5, sm: 0 }}>
            <Grid item xs={1.75} sm={1} display="flex" alignItems="center" gap={0.2}>
              <IconButton
                aria-label={open ? "Contraer detalle" : "Expandir detalle"}
                size="small"
                sx={{
                  width: { xs: 30, sm: 40 },
                  height: { xs: 30, sm: 40 },
                  p: 0,
                  flex: "0 0 auto",
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  setOpen((previous) => !previous);
                }}
              >
                {open ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
              </IconButton>
              <SoftTypography variant="caption" color="dark">
                {row.numero}
              </SoftTypography>
            </Grid>
            <Grid item xs={4.75} sm={6} display="flex" alignItems="center" minWidth={0}>
              <SoftTypography
                variant="caption"
                fontWeight="bold"
                sx={{ whiteSpace: "normal", overflowWrap: "anywhere", lineHeight: 1.3 }}
              >
                {nombreCompraDetalle(row)}
              </SoftTypography>
            </Grid>
            <Grid
              item
              xs={4}
              sm={2}
              display="flex"
              flexDirection="column"
              alignItems={{ xs: "flex-start", sm: "center" }}
              justifyContent="center"
            >
              <SoftTypography variant="caption" color="dark" fontWeight="bold" display={{ xs: "block", sm: "none" }}>
                Cantidad
              </SoftTypography>
              <SoftBox display="flex" flexWrap="wrap">
                <SoftTypography variant="caption" color="dark" fontWeight="medium">
                  {formatMoneyPunto(row.cantidadVerificada ?? 0)}
                </SoftTypography>
                <SoftTypography variant="caption" color="dark" fontWeight="medium">
                  &nbsp;
                  {row.requierePack && row.unidadPack
                    ? row.unidadPack
                    : row.unidadNombre || row?.materiaPrima?.tipoUnidad?.nombre || "Sin unidad"}
                </SoftTypography>
              </SoftBox>
            </Grid>
            {(row.file || !cotizada) && (
              <Grid
                item
                xs={1.5}
                sm={3}
                display="flex"
                flexDirection={{ xs: "column", sm: "row" }}
                alignItems="center"
                justifyContent="center"
                gap={{ xs: 0.4, sm: 0 }}
              >
                {row.file && (
                  <SoftButton
                    color="uproGreen"
                    circular
                    iconOnly
                    sx={{
                      padding: 0,
                      m: { xs: 0, sm: 0.5 },
                      width: { xs: 32, sm: 30 },
                      height: { xs: 32, sm: 30 },
                      minWidth: { xs: "32px !important", sm: "30px !important" },
                      boxShadow: { xs: "none", sm: "initial" },
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                      window.open(resolveStoredFileUrl(row.file), "_blank");
                    }}
                  >
                    <Icon sx={{ fontWeight: "light" }}>attach_file</Icon>
                  </SoftButton>
                )}
                {!cotizada && (
                  <>
                    <div>
                      <SoftButton
                        color={row.cotizaciones?.length > 0 ? "uproGreen" : "uproPink"}
                        circular
                        aria-label={
                          row.cotizaciones?.length > 0
                            ? `Editar cotización de ${row.materiaPrima?.nombre || row.nombreServicio || "producto"}`
                            : `Agregar cotización a ${row.materiaPrima?.nombre || row.nombreServicio || "producto"}`
                        }
                        sx={{
                          display: {
                            xs: "none",
                            lg: "flex",
                          },
                          m: 0.5,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpen(true);
                          openModal();
                        }}
                      >
                        <Icon sx={{ fontWeight: "light" }}>{row.cotizaciones?.length > 0 ? "check" : "add"}</Icon>
                        &nbsp;{row.cotizaciones?.length > 0 ? "Cotizado" : "Agregar Cotización"}
                      </SoftButton>
                    </div>
                    <SoftButton
                      color={row.cotizaciones?.length > 0 ? "uproGreen" : "uproPink"}
                      variant={row.cotizaciones?.length > 0 ? "outlined" : "gradient"}
                      circular
                      iconOnly
                      size="small"
                      aria-label={
                        row.cotizaciones?.length > 0
                          ? `Editar cotización de ${row.materiaPrima?.nombre || row.nombreServicio || "producto"}`
                          : `Agregar cotización a ${row.materiaPrima?.nombre || row.nombreServicio || "producto"}`
                      }
                      sx={{
                        display: {
                          xs: "flex",
                          lg: "none",
                        },
                        padding: 0,
                        m: 0,
                        width: 32,
                        height: 32,
                        minWidth: "32px !important",
                        minHeight: 32,
                        boxShadow: "none",
                        "&:hover": { boxShadow: "none" },
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpen(true);
                        openModal();
                      }}
                    >
                      <Icon sx={{ fontWeight: "light", fontSize: "17px !important" }}>
                        {row.cotizaciones?.length > 0 ? "check" : "add"}
                      </Icon>
                    </SoftButton>
                  </>
                )}
              </Grid>
            )}
          </Grid>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <SoftBox sx={{ margin: 1 }} py={1}>
              <SoftBox display="flex" justifyContent="space-between">
                <SoftTypography variant="h6" gutterBottom component="div">
                  Mis Cotizaciones
                </SoftTypography>
              </SoftBox>
              {row?.cotizaciones?.length > 0 ? (
                <>
                  <Grid container borderBottom="2px solid #e9ecef" display={{ xs: "none", sm: "flex" }}>
                    <Grid item xs>
                      <SoftTypography variant="caption" fontWeight="bold">
                        Nombre
                      </SoftTypography>
                    </Grid>
                    <Grid item xs={2} align="center">
                      <SoftTypography variant="caption" fontWeight="bold">
                        Precio unitario
                      </SoftTypography>
                    </Grid>
                    <Grid item xs={1} align="center">
                      <SoftTypography variant="caption" fontWeight="bold">
                        Cantidad
                      </SoftTypography>
                    </Grid>
                    <Grid item xs={1} align="center">
                      <SoftTypography variant="caption" fontWeight="bold">
                        Unidad
                      </SoftTypography>
                    </Grid>
                    <Grid item xs={2} align="center">
                      <SoftTypography variant="caption" fontWeight="bold">
                        Total
                      </SoftTypography>
                    </Grid>
                    <Grid item xs={2} align="center">
                      <SoftTypography variant="caption" fontWeight="bold">
                        Plazo de entrega
                      </SoftTypography>
                    </Grid>
                    {!cotizada && <Grid item xs={2} align="center"></Grid>}
                  </Grid>
                  {row.cotizaciones?.map((cotizacion, index) => (
                    <Fragment key={index}>
                      <SoftBox
                        display={{ xs: "block", sm: "none" }}
                        p={1.5}
                        mb={1}
                        sx={{
                          border: "1px solid #e4e8ee",
                          borderRadius: "12px",
                          backgroundColor: "#ffffff",
                          ...(!cotizada && {
                            cursor: "pointer",
                            transition: "border-color 180ms ease, background-color 180ms ease",
                            "&:hover": { borderColor: "primary.main", backgroundColor: "#fffafd" },
                          }),
                        }}
                        onClick={() => {
                          if (!cotizada) {
                            setProductoElegido({
                              ...row,
                              ...cotizacion,
                              indexEdit: index,
                            });
                          }
                        }}
                      >
                        <SoftTypography variant="caption" color="text" fontWeight="medium" display="block">
                          Producto ofrecido
                        </SoftTypography>
                        <SoftTypography
                          variant="button"
                          color="dark"
                          fontWeight="bold"
                          display="block"
                          mt={0.35}
                          sx={{ whiteSpace: "normal", overflowWrap: "anywhere", lineHeight: 1.35 }}
                        >
                          {cotizacion.nombreAlternativo
                            ? cotizacion.nombreAlternativo
                            : cotizacion?.requierePack && cotizacion?.unidadPack
                            ? cotizacion.nombreCompra
                            : cotizacion.nombre || "Mismo servicio que solicitado"}
                          {cotizacion.nombreAlternativo ? " (alternativo)" : ""}
                        </SoftTypography>

                        <SoftBox
                          display="grid"
                          gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                          columnGap={1.5}
                          rowGap={1.25}
                          mt={1.5}
                          pt={1.5}
                          sx={{ borderTop: "1px solid #edf0f3" }}
                        >
                          {[
                            ["Precio unitario", `$ ${formatMoneyPunto(cotizacion.precio)}`],
                            ["Cantidad", formatMoneyPunto(cotizacion.cantidad || row?.cantidadVerificada || 0)],
                            ["Unidad", cotizacion?.unidad || "Sin unidad"],
                            ["Total", `$ ${formatMoneyPunto((cotizacion.precio || 0) * (row?.cantidadVerificada || 0))}`],
                            ["Plazo de entrega", `${cotizacion.plazoEntrega} días corridos`],
                          ].map(([label, value]) => (
                            <SoftBox key={label} minWidth={0}>
                              <SoftTypography variant="caption" color="text" fontWeight="medium" display="block">
                                {label}
                              </SoftTypography>
                              <SoftTypography
                                variant="caption"
                                color="dark"
                                fontWeight="bold"
                                display="block"
                                mt={0.3}
                                sx={{ whiteSpace: "normal", overflowWrap: "anywhere", lineHeight: 1.35 }}
                              >
                                {value}
                              </SoftTypography>
                            </SoftBox>
                          ))}
                        </SoftBox>

                        {!cotizada && (
                          <SoftButton
                            color="dark"
                            variant="outlined"
                            size="small"
                            fullWidth
                            sx={{ mt: 1.5 }}
                            onClick={(event) => {
                              event.stopPropagation();
                              removeLicitacion(index, row?.id);
                            }}
                          >
                            <Icon sx={{ fontWeight: "light", mr: 0.5 }}>delete</Icon>
                            Quitar
                          </SoftButton>
                        )}
                      </SoftBox>

                    <Grid
                      container
                      display={{ xs: "none", sm: "flex" }}
                      p={1}
                      sx={
                        !cotizada ? {
                          cursor: "pointer",
                          borderRadius: "10px",
                          "&:hover": {
                            backgroundColor: "#f5f5f5",
                          },
                        } : undefined
                      }
                      onClick={() => {
                        setProductoElegido({
                          ...row,
                          ...cotizacion,
                          indexEdit: index,
                        });
                      }}
                    >
                      <Grid item xs>
                        <SoftTypography variant="caption" fontWeight="medium">
                          {cotizacion.nombreAlternativo
                            ? cotizacion.nombreAlternativo
                            : cotizacion?.requierePack && cotizacion?.unidadPack
                            ? cotizacion.nombreCompra
                            : cotizacion.nombre || "Mismo servicio que solicitado"}
                        </SoftTypography>
                        <SoftTypography variant="caption" fontWeight="medium" color={cotizacion.nombreAlternativo && "primary"}>
                          {cotizacion.nombreAlternativo ? " - (alternativo)" : ""}
                        </SoftTypography>
                      </Grid>
                      <Grid item xs={2} align="center">
                        <SoftTypography variant="caption" fontWeight="medium">
                          $ {formatMoneyPunto(cotizacion.precio)}
                        </SoftTypography>
                      </Grid>
                      <Grid item xs={1} align="center">
                        <SoftTypography variant="caption" fontWeight="medium">
                          {formatMoneyPunto(cotizacion.cantidad || row?.cantidadVerificada || 0)}
                        </SoftTypography>
                      </Grid>
                      <Grid item xs={1} align="center">
                        <SoftTypography variant="caption" fontWeight="medium">
                          {cotizacion?.unidad || "Sin unidad"}
                        </SoftTypography>
                      </Grid>
                      <Grid item xs={2} align="center">
                        <SoftTypography variant="caption" fontWeight="medium">
                          $ {formatMoneyPunto(cotizacion.precio * row?.cantidadVerificada ?? 0 ?? 0)}
                        </SoftTypography>
                      </Grid>
                      <Grid item xs={2} align="center">
                        <SoftTypography variant="caption" fontWeight="medium">
                          {cotizacion.plazoEntrega} días corridos
                        </SoftTypography>
                      </Grid>
                      {!cotizada && (
                        <Grid item xs={2} align="center">
                          {/* <Tooltip title="Editar" placement="top">
                            <Icon
                              sx={{
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setProductoElegido({
                                  ...row,
                                  ...cotizacion,
                                  indexEdit: index,
                                });
                              }}
                              color="primary"
                            >
                              edit
                            </Icon>
                          </Tooltip> */}
                          {/* <Tooltip title="Eliminar" placement="top">
                            <Icon
                              sx={{
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                removeLicitacion(index, row?.producto?.id);
                              }}
                            >
                              delete
                            </Icon>
                          </Tooltip> */}
                          <SoftButton
                            color="dark"
                            circular
                            size="small"
                            sx={{
                              display: {
                                xs: "none",
                                lg: "flex",
                              },
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              removeLicitacion(index, row?.id);
                            }}
                          >
                            <Icon sx={{ fontWeight: "light" }}>delete</Icon>
                            &nbsp;Quitar
                          </SoftButton>
                        </Grid>
                      )}
                    </Grid>
                    </Fragment>
                  ))}
                </>
              ) : (
                <SoftBox align="center">
                  <SoftTypography variant="caption" fontWeight="medium" textAlign="center">
                    No hay cotizaciones para este producto
                  </SoftTypography>
                </SoftBox>
              )}
            </SoftBox>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
}

FilaProducto.propTypes = {
  row: PropTypes.any,
  openModal: PropTypes.func,
  setProductoElegido: PropTypes.func,
  removeLicitacion: PropTypes.func,
  cotizada: PropTypes.bool,
};

export default FilaProducto;
